import { RenderHtml, ScrollView } from '@bonanza-social/moonlight';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectReferralRegistrationOffer } from '../../state';

function RAFTermsScreen() {
  const offer = useSelector(selectReferralRegistrationOffer());

  if (offer?.termsAndConditions === undefined) return null;

  return (
    <ScrollView
      contentContainerStyle={{
        padding: 'space-200',
      }}
      showsVerticalScrollIndicator={false}
    >
      <RenderHtml html={offer?.termsAndConditions} variant="body-m" />
    </ScrollView>
  );
}

export default RAFTermsScreen;
